import { Component, Input, OnInit } from '@angular/core'
import { KcDataService } from '../../kc-data.service'
import { KcLocaleData } from '../../interfaces/kc-data.interface'

@Component({
  selector: 'customer-portal-kc-localization-menu',
  templateUrl: './kc-localization-menu.component.html',
  styleUrls: ['./kc-localization-menu.component.scss']
})
export class KcLocalizationMenuComponent implements OnInit {
  constructor(private readonly kcDataService: KcDataService) {}

  @Input() color: string

  public localeData: KcLocaleData

  ngOnInit() {
    this.localeData = this.kcDataService.getLocaleData()
  }
}
